require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-major-general-emmett-j-bean-federal-center.json") })
        }
      }, "path---articles-tags-major-general-emmett-j-bean-federal-center");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-major-general-emmett-j-bean-federal-center!./.cache/json/articles-tags-major-general-emmett-j-bean-federal-center.json
// module id = 1886
// module chunks = 231608221292675